module.exports = __webpack_public_path__ + "img/qms2.52c11be5.png";